import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=3bdf72be&scoped=true"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"
import style0 from "./SessionDetails.vue?vue&type=style&index=0&id=3bdf72be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf72be",
  null
  
)

export default component.exports